import { apiURL } from "../../config";

export async function getCalendarDecisions(axiosPrivate, dateStart, dateEnd) {
	return axiosPrivate
		.get(`${apiURL}/decision/receiver/calendar.json?fromDate=${dateStart}&toDate=${dateEnd}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getCalendarUnits(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/user/organization-units.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				return res.data.map((e) => e.organizationUnit);
			}
		})
		.catch((err) => {
			return err.response;
		});
}
